<div #content class="ui-tooltip-menu">
    <div #wrapper [id]="guid" (click)="handleClick()">
        <ng-content></ng-content>
    </div>
</div>